import {
    MADE_FOR_YOU_LOADING,
    MADE_FOR_YOU_LOADING_SUCCESS,
    MADE_FOR_YOU_LOADING_ERROR,
    MADE_FOR_YOU_CLEAR_BETCARDS,
    MADE_FOR_YOU_SET_ACTIVE_TAB,
    MADE_FOR_YOU_PUSH_ACTIVE_TAB,
    MADE_FOR_YOU_SET_TAB_LIST,
    MADE_FOR_YOU_SET_IS_WIDGET,
    MADE_FOR_YOU_REMOVE_BET_CARD,
    MADE_FOR_YOU_SET_CURRENT_PAGE,
    MADE_FOR_YOU_INCREASE_CURRENT_PAGE,
    MADE_FOR_YOU_DECREASE_CURRENT_PAGE,
    MADE_FOR_YOU_INIT,
} from './mfyActionTypes';

export const mfyLoading = (status, betCardType) => {
    return {
        type: MADE_FOR_YOU_LOADING,
        status,
        betCardType,
    };
};

export const betcardsLoadSuccess = (data, betCardType) => {
    return {
        type: MADE_FOR_YOU_LOADING_SUCCESS,
        data,
        betCardType,
    };
};

export const betcardsHasErrored = (isError, betCardType) => {
    return {
        type: MADE_FOR_YOU_LOADING_ERROR,
        isError,
        betCardType,
    };
};

export const clearBetcards = () => {
    return {
        type: MADE_FOR_YOU_CLEAR_BETCARDS,
    };
};

export const removeBetcard = (betcardId) => {
    return {
        type: MADE_FOR_YOU_REMOVE_BET_CARD,
        betcardId,
    };
};

/**
 * Set the active tab, without affecting the browser's history.
 * @param {string} tab The active tab
 * @returns {object} object
 */
export const setActiveTab = (tab) => {
    return {
        type: MADE_FOR_YOU_SET_ACTIVE_TAB,
        tab,
    };
};

/**
* Set the active tab, pushing the new state in the browser's history.
* @param {string} tab The active tab
* @returns {object} object
 */
export const pushActiveTab = (tab) => {
    return {
        type: MADE_FOR_YOU_PUSH_ACTIVE_TAB,
        tab,
    };
};

export const setTabList = (tabList) => {
    return {
        type: MADE_FOR_YOU_SET_TAB_LIST,
        tabList,
    };
};

export const setIsMadeForYouWidget = (isMadeForYouWidget = false) => ({
    type: MADE_FOR_YOU_SET_IS_WIDGET,
    isMadeForYouWidget,
});

export const setCurrentPage = (pageNumber) => ({
    type: MADE_FOR_YOU_SET_CURRENT_PAGE,
    pageNumber,
});

export const incrementCurrentPage = () => ({
    type: MADE_FOR_YOU_INCREASE_CURRENT_PAGE,
});

export const decrementCurrentPage = () => ({
    type: MADE_FOR_YOU_DECREASE_CURRENT_PAGE,
});

export const initReduxState = (isWidget = false) => ({
    type: MADE_FOR_YOU_INIT,
    isWidget,
});
